import { render, staticRenderFns } from "./tableHome.vue?vue&type=template&id=51107f9b&scoped=true"
import script from "./tableHome.vue?vue&type=script&lang=js"
export * from "./tableHome.vue?vue&type=script&lang=js"
import style0 from "./tableHome.vue?vue&type=style&index=0&id=51107f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51107f9b",
  null
  
)

export default component.exports